import styled, { css } from 'styled-components';
import colors from '../../../../helpers/colors';
import fonts from '../../../../helpers/fonts';
import mediaQuery from '../../../../helpers/mediaQuery';
import spacing from '../../../../helpers/spacing';
import { PrimaryCta, SecondaryCta } from '../../../Cta';
import Link from '../../../Link';
import { navItemSelectedBarHeight } from '../../Header/styles';
import {
  centredIconAndTextStyles,
  IconBackground,
} from '../../commonStyles/secondaryNavStyles';
import {
  InlineNav,
  navItemSelectedBar,
  NavItemText,
  NavItemWithoutBorder,
} from '../styles';

export const InlineSecondaryNav = styled(InlineNav)`
  ${mediaQuery.tabletLandscape`
    justify-content: flex-end;
  `}
`;

export const SecondaryNavItemWrapper = styled.div`
  display: flex;
  position: relative;
`;

export const NavItem = styled(NavItemWithoutBorder)`
  ${navItemSelectedBar(colors.core03)}
`;

export const SecondaryNavItemText = styled(NavItemText)`
  padding: 0 ${spacing(1.5)};

  ${centredIconAndTextStyles}
`;

export const DesktopIconBackground = styled(IconBackground)`
  margin-right: ${spacing(1)};
`;

export const SecondaryMenu = styled.div<{ alignRight: boolean }>`
  display: none;

  position: absolute;
  top: calc(100% + ${navItemSelectedBarHeight});
  ${({ alignRight }) => (alignRight ? 'right: 0;' : 'left: 0;')}
  width: 240px;

  ${mediaQuery.desktop`
    width: 290px;
  `}

  background: ${colors.neutral08};
  border-radius: 0 0 8px 8px;

  ${mediaQuery.tabletLandscape`
    display: block;
  `}
`;

export const MenuContent = styled.div`
  padding: ${spacing(3)} ${spacing(4)} ${spacing(4)};

  box-shadow: 0 12px 17px 2px rgba(0, 0, 0, 0.14), 0 5px 22px 4px rgba(0, 0, 0, 0.12),
    0 7px 8px -4px rgba(0, 0, 0, 0.2);

  > *:first-child {
    margin-top: 0;
  }
`;

export const SectionHeading = styled.h3`
  ${fonts.headingXSmall}
  margin: ${spacing(3)} 0 ${spacing(4)};
`;

export const SectionLinks = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

export const LinkWrapper = styled.li`
  ${fonts.paragraph}

  margin: ${spacing(1)} 0;

  &:last-child {
    margin-bottom: 0;
  }
`;

/* Empty for Motability, where overriding styling is applied */
export const StyledLink = styled(Link)``;

const ctaStyles = css`
  margin-top: ${spacing(2)};

  :first-of-type {
    margin-top: ${spacing(4)};
  }
`;

export const StyledPrimaryCta = styled(PrimaryCta)`
  ${ctaStyles}
`;

export const StyledSecondaryCta = styled(SecondaryCta)`
  ${ctaStyles}
`;
